// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app"
import { getAnalytics } from "firebase/analytics"
import { getAuth } from "firebase/auth"
import { getMessaging } from "firebase/messaging"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCT6WJ2u1YdOwEbFGblQPDT3LJJs3lPwFI",
    authDomain: "namdjetest-a5bc6.firebaseapp.com",
    projectId: "namdjetest-a5bc6",
    storageBucket: "namdjetest-a5bc6.appspot.com",
    messagingSenderId: "940941961310",
    appId: "1:940941961310:web:123b84d85e48112a4f2ccf",
    measurementId: "G-1XDYCKFMXY"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
const analytics = getAnalytics(app)
const auth = getAuth(app)
const messaging = getMessaging(app)

export {
    analytics,
    auth,
    messaging,
}
